<template>
  <section class="search-body" v-if="listOfFlights">
    <section class="search__wrapper">
      <div class="mb-3" style="margin-left: 70px">
        <router-link to="/lifestyle/flight">
          <button type="button" class="btn btn-outline-none text-danger">Go Back</button>
        </router-link>
      </div>
      <div class="row">
        <!-- <div class="col-lg-3">
          <div class="filter__header">
            <div class="filter__section--header d-flex justify-content-between align-items-center">
              <h5>Filter</h5>
              <div class="d-flex align-items-center">
                <h6 class="clear-all-text">Clear All</h6>
                <button type="button" class="btn btn-danger btn-apply ml-3">Apply</button>
              </div>
            </div>
            <hr>
            <div class="price-section">

            </div>
          </div>
        </div> -->
        <div class="col-lg-9 offset-lg-1">
          <div class="flight__section">
            <h5 class="avail-text">Available Flights</h5>
          </div>
          <div class="row avail-items">
            <div class="col-lg-6 pb-3" v-for="(flight, key) in listOfFlights" :key="key">
              <router-link :to="{ name: 'flight-view', params: { id: flight.selectData } }">
              <section>
                <div class="flight__check d-flex justify-content-between align-items-start">
                  <section>
                    <div class="row">
                      <div class="col-lg-12" v-for="(items, key) in flight.flightCombination.flightModels" :key="key">
                        <div class="px-3 pt-2 d-flex align-items-center">
                          <img :src="items.airlineLogoUrl" width="50" alt="">
                          <p class="ml-2">{{items.airlineName}}</p>
                        </div>
                        <div class="d-flex">
                          <div class="px-3 pt-1 text-center">
                            <h5>{{items.departureTime | moment}}</h5>
                            <h6>{{items.departureCode}}</h6>
                          </div>
                          <div class="px-3 pt-1 text-center">
                            <p>{{items.tripDuration}}</p>
                            <p>{{items.stops + ' Stop'}}</p>
                          </div>
                          <div class="px-3 pt-1 text-center">
                            <h5>{{items.arrivalTime | moment}}</h5>
                            <h6>{{items.arrivalCode}}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                    <div class="last-side" :class="flight.flightCombination.flightModels.length > 1 ? 'set-height': ''">
                      <!-- <div class="last-side-header">
                        <p>Travel Fest Deal</p>
                      </div> -->
                      <div class="pr-4 pl-2 text-right pb-4" :class="flight.flightCombination.flightModels.length > 1 ? 'mt-90': 'mt-5'">
                        <p class="pay-full text-right">Pay Full Fare</p>
                        <h5 class="amount pt-1">N{{new Intl.NumberFormat('en-NG', {}).format(flight.flightCombination.price.amount)}}</h5>
                      </div>
                    </div>
                </div>
              </section>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import flightData from '@/data/flight';
  import moment from 'moment';
  export default {
    filters: {
      moment: function (date) {
        return moment(date).format('HH:MM');
      }
    },
    data:()=>({
      availableFlight: flightData.data.flight
    }),
    computed:{
      ...mapState('flight', ['listOfFlights'])
    }
  };
</script>

<style scoped>
hr {
  margin: 0;
  padding: 0;
}
.set-height {
  height: 224px !important;
}
.mt-90 {
  margin-top: 90px;
}
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.search__wrapper {
  padding: 40px 0px
}
.filter__section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  height: 500px;
}
.filter__header {
  background-color: #fff;
  margin-bottom: 20px;
  height: 500px;
}
.flight__check {
  background-color: #fff;
  margin-bottom: 20px;
  height: 100%;
  border-radius: 7px;
}
.filter__section--header {
  padding: 30px 20px;
}
.filter__section--header h5 {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.clear-all-text {
  letter-spacing: 0px;
  color: #E41613;
  opacity: 1;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 0px;
}
.btn-apply {
  padding: 3px 26px !important;
}
.flight__section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
}
.avail-items {
  height: 600px;
  overflow: scroll;
}
.avail-text {
  letter-spacing: 0px;
  color: #232949;
  opacity: 1;
  font-size: 15px;
  font-weight: 800;
  margin-bottom: 0;
}
.last-side {
  background:#F4FAFE;
  width: 135px;
  height: 100%;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
.last-side-header {
  padding: 8px;
  background: #23384D;
  color: #fff;
  text-align: center;
  border-top-right-radius: 7px;
}
.last-side-header p {
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0;
}
.px-3 p {
  margin-bottom: 0;
  letter-spacing: 0px;
  color: #6D8494;
  opacity: 1;
  font-size: 11px;
  font-weight: normal;
}
.px-3 h5 {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 14px;
  font-weight: bold;
}
.px-3 h6 {
  letter-spacing: 0px;
  color: #6D8494;
  opacity: 1;
  font-size: 14px;
  font-weight: normal;
}
.pay-full {
  letter-spacing: 0px;
  color: #E41613 !important;
  opacity: 1;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 0;
}
.amount {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 21px;
  font-weight: bold;
}
</style>